import { IEnvironment } from "./environment";

export const releaseEnv: IEnvironment = {
  env: "release",
  api: {
    protocol: "https",
    host: "api.staging.aurora.codebehind.tech",
  },
};
